<ng-container *ngIf="!empty()">  
  <div class="data-table-title">
    <div>
      <select class="text-title" *ngIf="configs.length > 1" (change)="select()" #sel>
        <ng-container *ngFor="let config of configs; index as i">
          <option *ngIf="valid(config)" value="{{i}}">{{config.title}}</option>
        </ng-container>
      </select>
      <span class="text-title" *ngIf="configs.length == 1">{{config.title}}</span>
      <span i *ngIf="helpable()">&nbsp;<i class="fa fa-question-circle text-primary" (click)="help()"></i></span>
      <i *ngIf="exportable()" class="fa fa-download" (click)="export()"></i>
    </div>
    <div class="data-table-filter" *ngIf="filterable() || groupable()">
      <input *ngIf="filterable()" type="text" placeholder="lọc dữ liệu" (keyup)="update()" #search />
      <i *ngIf="groupable()" class="fa fa-filter" (click)="show($event)"></i>
    </div>
    <small *ngIf="config.count != false">{{filtered.length == data.length ? 'Có' : 'Trùng'}} <b>{{filtered.length}}</b> <span *ngIf="filtered.length != data.length"> trong số {{data.length}}</span> kết quả</small>
  </div>

  <table class="table data-table-content" #_table (domChange)="dom()">
    <ng-container *ngIf="filtered != null && filtered.length > 0">
      <thead #_thead style="position:absolute; top: 0">
        <tr>
          <ng-container *ngFor="let col of config.columns">
            <th *ngIf="col.visible !== false" class="{{col.class}}" [innerHtml]="col.title"></th>
          </ng-container>
        </tr>
      </thead>
      <thead style="opacity: 0">
        <tr>
          <ng-container *ngFor="let col of config.columns">
            <th *ngIf="col.visible !== false" class="{{col.class}} dummy" [innerHtml]="col.title" width="{{col.width ? col.width : '*'}}"></th>
          </ng-container>
        </tr>
      </thead>
    </ng-container>
    <ng-container *ngIf="config.multibody == true">
      <tbody *ngFor="let item of filtered">
        <tr>
          <ng-container *ngFor="let col of config.columns">
            <td *ngIf="col.visible !== false" class="{{css(col, item)}}" [innerHtml]="col.html(item)" (click)="click(col, item)"></td>
          </ng-container>
        </tr>
      </tbody>
    </ng-container>
    <ng-container *ngIf="config.multibody !== true">
      <tbody>
        <tr *ngFor="let item of filtered">
          <ng-container *ngFor="let col of config.columns">
            <td *ngIf="col.visible !== false" class="{{css(col, item)}}" [innerHtml]="col.html(item)" (click)="click(col, item)"></td>
          </ng-container>
        </tr>
      </tbody>
    </ng-container>
    <ng-container *ngIf="footer !== null && filtered != null && filtered.length > 0">
      <tfoot style="opacity:0">
        <tr>
          <ng-container *ngFor="let item of footer">
            <td *ngIf="item.visible !== false" class="{{item.class}}" [innerHtml]="item.html"></td>
          </ng-container>
        </tr>
      </tfoot>
      <tfoot #_tfoot style="position: absolute; bottom: 0">
        <tr>
          <ng-container *ngFor="let item of footer">
            <td *ngIf="item.visible !== false" class="{{item.class}}" [innerHtml]="item.html"></td>
          </ng-container>
        </tr>
      </tfoot>
    </ng-container>
  </table>
</ng-container>

<div *ngIf="groups != null" class="modal fade" #popup tabindex="-1" role="dialog" aria-hidden="false">
  <div class="modal-dialog data-table-popup" role="document">
    <div class="modal-content">
      <i class="button fa fa-close" (click)="hide($event)"></i>
      <p><b class="text-info">LỌC DỮ LIỆU</b><br />Hãy đánh giấu nhóm bạn muốn xem</p>
      <div class="data-table-popup-content">
        <ul>
          <li class="checkbox" *ngFor="let group of groups">
            <label (click)="toggle(group, null); update()">
              <span class="fa fa-check" [ngClass]="{'active' : group.selected}"></span>
              <span [innerHtml]="group.html"></span>
            </label>
            <ul>
              <li class="checkbox" *ngFor="let child of group.children">
                <label (click)="toggle(group, child); update()">
                  <span class="fa fa-check" [ngClass]="{'active' : child.selected}"></span>
                  <span [innerHtml]="child.html"></span>
                </label>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
